export const SHOPPING_FOR_OPTIONS = [
  { value: "self", label: "Mostly for myself" },
  { value: "gift", label: "Often buying gifts" },
  { value: "household", label: "Shared household" },
  { value: "work", label: "Work / business" },
];

export const LIFE_ROLE_OPTIONS = [
  { value: "student", label: "Student" },
  { value: "professional", label: "Working professional" },
  { value: "parent", label: "Parent / family" },
  { value: "enthusiast", label: "Tech enthusiast" },
  { value: "other", label: "Other" },
];

export const TECH_RELATIONSHIP_OPTIONS = [
  { value: "daily", label: "Daily essential tool" },
  { value: "occasional", label: "Occasional use" },
  { value: "enthusiast", label: "Love specs & upgrades" },
  { value: "professional", label: "Professional / creative work" },
];

export const ECOSYSTEM_OPTIONS = [
  { value: "agnostic", label: "No strong preference" },
  { value: "apple", label: "Apple" },
  { value: "android", label: "Android" },
  { value: "windows", label: "Windows PC" },
  { value: "other", label: "Other" },
];

export const DEAL_BREAKER_SUGGESTIONS = [
  "No subscriptions",
  "Must have long battery",
  "Compact size",
  "Repairable",
  "Privacy focused",
];
